import { createStructuredSelector } from 'reselect'
import {
  MGMT_OBJECTIVE_LIST, MGMT_OBJECTIVE_LIST_SUCCESS, MGMT_OBJECTIVE_LIST_ERROR,
  MGMT_OBJECTIVE_PAGE_SET, MGMT_OBJECTIVE_ADD, MGMT_OBJECTIVE_ADD_SUCCESS,
  MGMT_OBJECTIVE_ADD_ERROR, MGMT_OBJECTIVE_ADD_CHANGE, MGMT_OBJECTIVE_DETAIL,
  MGMT_OBJECTIVE_DETAIL_SUCCESS, MGMT_OBJECTIVE_DETAIL_ERROR, MGMT_OBJECTIVE_UPDATE,
  MGMT_OBJECTIVE_UPDATE_SUCCESS, MGMT_OBJECTIVE_UPDATE_ERROR,
} from '../../actions';

export const NAME = 'mgmt_objective';

export const MgmtObjectiveList = (page, num_page, orderBy, filters) => ({ type: MGMT_OBJECTIVE_LIST, payload: { page, num_page, orderBy, filters } });
export const MgmtObjectiveListSuccess = (data) => ({ type: MGMT_OBJECTIVE_LIST_SUCCESS, payload: data });
export const MgmtObjectiveListError = (error) => ({ type: MGMT_OBJECTIVE_LIST_ERROR, payload: error });
export const MgmtObjectivePageSet = (data) => ({ type: MGMT_OBJECTIVE_PAGE_SET, payload: data });
export const MgmtObjectiveAddChangeSet = (data) => ({ type: MGMT_OBJECTIVE_ADD_CHANGE, payload: data });
export const MgmtObjectiveAdd = (data) => ({ type: MGMT_OBJECTIVE_ADD, payload: data });
export const MgmtObjectiveAddSuccess = (message) => ({ type: MGMT_OBJECTIVE_ADD_SUCCESS, payload: message });
export const MgmtObjectiveAddError = (error) => ({ type: MGMT_OBJECTIVE_ADD_ERROR, payload: error });
export const MgmtObjectiveDetail = (data) => ({ type: MGMT_OBJECTIVE_DETAIL, payload: data });
export const MgmtObjectiveDetailSuccess = (data) => ({ type: MGMT_OBJECTIVE_DETAIL_SUCCESS, payload: data });
export const MgmtObjectiveDetailError = (error) => ({ type: MGMT_OBJECTIVE_DETAIL_ERROR, payload: error });
export const MgmtObjectiveUpdate = (data) => ({ type: MGMT_OBJECTIVE_UPDATE, payload: data });
export const MgmtObjectiveUpdateSuccess = (message) => ({ type: MGMT_OBJECTIVE_UPDATE_SUCCESS, payload: message.message });
export const MgmtObjectiveUpdateError = (error) => ({ type: MGMT_OBJECTIVE_UPDATE_ERROR, payload: error });

const mgmt_objective = (state) => state[NAME];
export const MgmtObjectiveSelector = createStructuredSelector({ mgmt_objective });
